import React from 'react';
import { Shield } from 'lucide-react';

const PoliticaPrivacidade = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
    <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-sm p-6 sm:p-8">
      <div className="flex items-center gap-2 mb-6">
        <Shield className="h-8 w-8 text-primary-600" />
        <h1 className="text-2xl font-bold text-gray-900">Política de Privacidade</h1>
      </div>
      <p className="text-gray-600 mb-2">SindicoON - Sistema de Gestão de Condomínios</p>
      <p className="text-sm text-gray-500 mb-8">Última atualização: 2025</p>

      <div className="prose prose-gray max-w-none space-y-6">
        <section>
          <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">1. Introdução</h2>
          <p className="text-gray-700 leading-relaxed">
            Esta Política de Privacidade descreve como o aplicativo SindicoON coleta, usa e protege
            as informações dos usuários. Ao utilizar o sistema (web e app), você concorda com os termos aqui descritos.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">2. Dados que Coletamos</h2>
          <p className="text-gray-700 leading-relaxed">
            Coletamos apenas os dados necessários para o funcionamento do sistema e da gestão do
            condomínio, tais como: nome, e-mail, telefone, unidade/bloco, dados de acesso à conta e
            informações que você insere ao usar as funcionalidades (encomendas, visitantes, ocorrências,
            reservas, documentos, notas fiscais, entre outras).
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">3. Uso da Câmera e Armazenamento (App)</h2>
          <p className="text-gray-700 leading-relaxed">
            O aplicativo móvel solicita permissão de câmera e armazenamento para: anexar fotos às notas fiscais,
            registrar fotos de encomendas, áreas comuns, achados e perdidos, e documentos quando necessário.
            As imagens são enviadas aos servidores apenas para as finalidades descritas e em conformidade com esta política.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">4. Finalidade do Tratamento</h2>
          <p className="text-gray-700 leading-relaxed">
            Os dados são utilizados para: prestar os serviços de gestão condominial, identificar o
            usuário e sua unidade, permitir o envio de comunicados, controle de visitantes e encomendas,
            gestão financeira e documental, e melhorar a experiência de uso do sistema.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">5. Compartilhamento</h2>
          <p className="text-gray-700 leading-relaxed">
            As informações são compartilhadas apenas com o condomínio ao qual você está vinculado e com
            os administradores/síndicos autorizados, na medida necessária para a gestão. Não vendemos
            nem repassamos seus dados a terceiros para fins de marketing.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">6. Segurança</h2>
          <p className="text-gray-700 leading-relaxed">
            Adotamos medidas técnicas e organizacionais para proteger seus dados contra acesso não
            autorizado, perda ou alteração indevida.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">7. Seus Direitos</h2>
          <p className="text-gray-700 leading-relaxed">
            Você pode solicitar acesso, correção ou exclusão dos seus dados pessoais entrando em contato
            com o administrador do seu condomínio ou através do canal de suporte disponível no sistema.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">8. Contato</h2>
          <p className="text-gray-700 leading-relaxed">
            Dúvidas sobre esta política podem ser enviadas pelo formulário de suporte (Fale Conosco) ou
            ao administrador do condomínio.
          </p>
        </section>
      </div>
    </div>
    </div>
  );
};

export default PoliticaPrivacidade;
